module.exports = __webpack_public_path__ + "img/dice-yxx3-5.359f9fc2.svg";